import React from 'react';
import './ContactInfo.css';

import { contactContent } from '../../constants'; // Import contact data



const ContactInfo = () => {
  return (
    <div className='contact-info'>    
      {
        // Loop through each contact item in the contactContent array
        contactContent.map((contact) => {

          let details = contact.content;

          return (
            <div className='info-item' key={contact.id}>

              <div className='icon'>{contact.icon}</div> {/* Contact method Icon */}
              <h3>{contact.title}</h3> {/* Contact method Title */}
              {/* Render each item in the contact details as a separate paragraph */}
              <ol>
                {details.map((item, index) => {
                  return <p key={index}>{item}</p>
                })}
              </ol>

            </div>
          )
        })
      }
    </div>
  )
}

export default ContactInfo;